import React from 'react';
import RDatePicker from 'react-date-picker';
import TodayIcon from '@material-ui/icons/Today';

import './style.css';

const DatePicker = React.memo(props => <RDatePicker {...props} calendarIcon={<TodayIcon />} />);

export default DatePicker;
